import styled from 'styled-components';

export const Wrapper = styled.div`
  padding-bottom: ${({ $paddingBottom, theme }) =>
    $paddingBottom ? theme.spacing.medium : 0};

  p:last-of-type {
    margin-bottom: ${({ $paddingBottom }) => ($paddingBottom ? 0 : null)};
  }
`;
